import { PageHeading } from '@src/components/PageHeading/PageHeading';
import type { ReactNode } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, ChevronLeftIcon } from '@src/components';
import { Landscape } from '@src/components/Landscape/Landscape';
import './FullPageShell.css';

export function FullPageShell({
  title,
  children,
  className = '',
  testId,
  backTestId,
}: {
  title: string;
  children: ReactNode;
  className?: string;
  testId?: string;
  backTestId?: string;
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <main className={`full-page-shell ${className}`} data-testid={testId} data-app-version="v2">
      <div className="full-page-shell__landscape" aria-hidden="true">
        <Landscape appearance="soft" parallax={false} />
      </div>
      <div className="full-page-shell__content">
        <Button
          className="full-page-shell__back"
          variant="ghost"
          icon={<ChevronLeftIcon />}
          onClick={() => (location.key === 'default' ? navigate('/') : navigate(-1))}
          testId={backTestId}
        >
          {t('creation.back')}
        </Button>
        <PageHeading title={<>{title}</>} />
        {children}
      </div>
    </main>
  );
}
